import { SingleTemplateModel } from 'templates/types';
import { API_URL } from 'utils/endpoints';
import { OtherTemplatesResponseModel } from './types';
import { TEMPLATES_REQUEST_LIMIT } from '../pages/Categories/constants';

const getRelatedTemplates = async (
  templateData: SingleTemplateModel,
  page?: string,
  headers?: any,
): Promise<OtherTemplatesResponseModel> => {
  const relatedTemplatesUrl = `${API_URL}/templates/discover/ratio?ratio=${templateData.subtypes[0]}&market=website&limit=${TEMPLATES_REQUEST_LIMIT}`;
  const relatedResponse = await fetch(page || relatedTemplatesUrl, {
    headers,
  });

  const relatedTemplatesData = await relatedResponse.json();

  const otherTemplates =
    relatedTemplatesData.response
      ?.map(template => ({
        ...template,
        url: template.preview_url,
      }))
      ?.filter(item => item.id !== templateData.id.toString()) || [];

  return {
    response: otherTemplates,
    metadata: {
      next_page: relatedTemplatesData.metadata.next_page,
    },
  };
};

export default getRelatedTemplates;
